module.exports = __webpack_public_path__ + "static/logoCott-20830e2294fa04e020c2818d93419c59.jpg";